import React from 'react'
import { connect } from 'react-redux'
import { addListItem, changeListItem, deleteListItem, getListItems, getMixedListValues, nullDate, TDate, getListIds } from 'Tyan/public/utility'
import { hasChangedValues, getFormValue, changeItemsValue } from 'Tyan/public/utility/formValues'
class BatchSetDiv extends React.Component {
    state = {
        changedValues基本信息: {},
    }
    componentDidMount = () => {
        const { id, person } = this.props
        Tyan.doPostEvent({
            event: 'GetUseVacationInfoList',
            data: { id, person },
            onEnd: ({ errorMessage, initValues基本信息, optionsParas }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                }
                else {
                    this.setState({ id, initValues基本信息, changedValues基本信息: {}, optionsParas })
                }
            }
        })
    }

    handlerSave = () => {
        const { id, onSave, onClose } = this.props
        const { changedValues基本信息 } = this.state
        Tyan.doPostEvent({
            event: 'SaveUseVacationInfoList',
            data: { id, changedValues基本信息 },
            onEnd: ({ errorMessage }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                }
                else {
                    onClose && onClose()
                    onSave && onSave(id)
                }
            }
        })
    }

    handlerClose = () => {
        const { onClose, onSave, id } = this.props
        if (!this.bChanged()) {
            onClose && onClose()
            onSave && onSave(id)
            return
        }
        Tyan.pubForm.showConfirm('确定要放弃更改吗？', onClose)
    }

    bChanged = () => {
        return hasChangedValues(this)
    }

    bSave = () => {
        return hasChangedValues(this)
    }

    handleSelectChange = (v, fieldName) => {
        const ids = getListIds(this, '基本信息', '休假人员列表')
        changeListItem(this, Array(ids.length).fill({ [fieldName]: v }), { [fieldName]: 'string' }, '基本信息', '休假人员列表', ids)
    }

    fieldset基本信息 = () => {
        const ids = getListIds(this, '基本信息', '休假人员列表')
        const p = { margin: '5px 15px 5px 15px', minWidth: 150, _full: true, flex: 1 }
        return [].concat([{
            _group: '', padding: '0 10 0 0', minWidth: '90%', items: [
                { _label: '休假人员', ...p, },
                { _datetime: '', name: '开始时间', placeholder: '开始时间', ...p, onChange: (v) => this.handleSelectChange(v, '开始时间') },
                { _datetime: '', name: '结束时间', placeholder: '结束时间', ...p, onChange: (v) => this.handleSelectChange(v, '结束时间') },
                { _label: '职务代理人', ...p, },
            ]
        }]).concat([{
            _group: '', margin: '0', items: ids.map(id => ({
                _group: '', padding: '0 10 0 0', list: { listName: '休假人员列表', id }, minWidth: '90%', items: [
                    { _text: '', name: '休假人员', disabled: true, ...p, },
                    { _datetime: '', name: '开始时间', ...p, },
                    { _datetime: '', name: '结束时间', ...p, },
                    { _select: '', name: '职务代理人', optionName: id, ...p, },
                ]
            }))
        }])
    }

    render() {
        const { showMessage: Message, showBody: Body } = this.props
        const { errorMessage } = this.state
        if (errorMessage) return Tyan.pubForm.showError(errorMessage)
        return <Body data={this} maxWidth={'1200'}
            controls={[
                { _button: '保存', icon: 'save', handler: this.handlerSave, disabled: !this.bSave(), },
                { _button: this.bChanged() && '取消' || '关闭', icon: 'close', handler: this.handlerClose },
            ]}
            fieldsets={
                [
                    { title: '', name: '基本信息', _fieldset: this.fieldset基本信息(), },
                ]
            }
        />
    }
}

export default connect()(BatchSetDiv)